/*
 * @File Name: I18n
 * @Author: zhuzhaoyang
 * @Date: 2023-06-13 13:31:15
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-06-19 10:32:20
 * @Description: 
 * @FilePath: /src/global/i18n/index.ts
 */
import { createI18n } from 'vue-i18n'
import type { I18n } from 'vue-i18n'
import zhCN from '@/global/i18n/lang-pack/zh-CN';
import EN from '@/global/i18n/lang-pack/en';
const defaultLang = localStorage.getItem('lang') || 'zh-CN'
// 默认多语言
const i18n:I18n = createI18n({
  locale: defaultLang,
  legacy: false,
  messages: {
    'zh-CN': zhCN,
    'en': EN
  }
})
export default i18n